export const TOKEN_TYPE = {
  PRIVATE: 'PRIVATE',
  PUBLIC: 'PUBLIC',
}

export const KEY_STATUS = {
  ACTIVE: 1,
  INACTIVE: 0,
}
